import { createContext, useContext } from 'react';
import { logInfo, logDebug, logError, notifyError } from '../utils/logs.js';
import { jsx } from 'react/jsx-runtime';
const defaultProps = {
  logInfo,
  logDebug,
  logError,
  notifyError
};
const LoggerContext = /*#__PURE__*/createContext(defaultProps);
function LoggerProvider({
  children,
  logger
}) {
  return /*#__PURE__*/jsx(LoggerContext.Provider, {
    value: {
      logInfo: logger?.logInfo || defaultProps.logInfo,
      logDebug: logger?.logDebug || defaultProps.logDebug,
      logError: logger?.logError || defaultProps.logError,
      notifyError: logger?.notifyError || defaultProps.notifyError
    },
    children: children
  });
}
const useLogger = () => useContext(LoggerContext);
export { LoggerProvider, useLogger };
//# sourceMappingURL=LoggerProvider.js.map
